import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import Crumb from "features/breadcrumbs/Crumb";

const OrdersCrumb: React.FC = () => {
  return (
    <Crumb to="/orders" icon={<PlaylistAddCheckIcon />}>
      Ordrar
    </Crumb>
  );
}

export default OrdersCrumb;
